import { render, staticRenderFns } from "./AddMultipleTarget.vue?vue&type=template&id=540339b8&"
import script from "./AddMultipleTarget.vue?vue&type=script&lang=js&"
export * from "./AddMultipleTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports